import { Outlet } from 'react-router-dom';

import { SystemTemplatesSectionsContainer } from './SystemTemplatesTab.styles';
import SystemTemplatesTabHeader from './header/SystemTemplatesTabHeader';
import MessagesSentToGuestsSection from './sections/MessagesSentToGuestsSection';
import MessagesSentToPropertyManagersSection from './sections/MessagesSentToPropertyManagersSection';
import MessagesSentToPropertyOwnersSection from './sections/MessagesSentToPropertyOwnersSection';
import MessagesSentToServiceProvidersSection from './sections/MessagesSentToServiceProvidersSection';

const SystemTemplatesTab = () => {
  return (
    <>
      <SystemTemplatesTabHeader />
      <SystemTemplatesSectionsContainer>
        <MessagesSentToGuestsSection />
        <MessagesSentToPropertyManagersSection />
        <MessagesSentToPropertyOwnersSection />
        <MessagesSentToServiceProvidersSection />
      </SystemTemplatesSectionsContainer>
      <Outlet />
    </>
  );
};

export default SystemTemplatesTab;
